import * as general from './general'

export const paymentMethodHelper = {
  general,
}
